<template>
  <div>
    <div v-for="(block, index) in blockList" class="data-card" :key="block.text">
      <p class="block-name">{{ block.text }}</p>
      <v-divider></v-divider>
      <div>
        <div v-for="(data1, deviceId) in groupedByBlock[block.id]" :key="deviceId">
          <v-divider></v-divider>
          <div class="device-header">
            <span class="device-name">{{ data1['name'] }}</span>
            <span v-if="loggerDisconnected[deviceId]" class="device-status-badge disconnected">
              <v-icon x-small class="status-icon">wifi_off</v-icon>
              Logger Disconnected
            </span>
            <span v-else-if="deviceConnected[deviceId] === false || deviceConnected[deviceId] === undefined" class="device-status-badge stale">
              <v-icon x-small class="status-icon">access_time</v-icon>
              Data Outdated
            </span>
            <span v-else class="device-status-badge connected">
              <v-icon x-small class="status-icon">check_circle</v-icon>
              Live
            </span>
          </div>
          <v-layout class="status-container" row wrap>
            <template v-if="paramNameMap[deviceId]">
              <v-flex v-for="(displayName, param) in paramNameMap[deviceId]" :key="param" xs2>
                <div v-if="healthyValues[param] && healthyValues[param]['healthy_value'] !== undefined" class="status-card" :class="data1[param] == healthyValues[param]['healthy_value'] ? 'status-on' : data1[param] == null ? 'no-status' : 'status-off'">
                  <div class="truncate">{{ displayName }}</div>
                </div>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blockList: {
      type: Array,
      default: function() {
        return []
      }
    },
    groupedByBlock: {
      type: Object,
      default: function() {
        return {}
      }
    },
    healthyValues: {
      type: Object,
      default: function() {
        return {}
      }
    },
    paramNameMap: {
      type: Object,
      default: function() {
        return {}
      }
    },
    deviceConnected: {
      type: Object,
      default: function() {
        return {}
      }
    },
    loggerDisconnected: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}
</script>

<style scoped>

.data-card {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 25px;
  background-color: var(--v-primary-base);
  border-radius: 12px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.block-name {
  font-weight: bolder;
  font-size: 18px;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.device-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 20px 10px 20px;
  flex-wrap: wrap;
}

.device-name {
  font-size: medium;
  font-weight: 500;
}

.device-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.device-status-badge.connected {
  background: rgba(76, 175, 80, 0.15);
  color: #4CAF50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.device-status-badge.disconnected {
  background: rgba(239, 83, 80, 0.15);
  color: #EF5350;
  border: 1px solid rgba(239, 83, 80, 0.3);
  animation: pulse-badge 2s ease-in-out infinite;
}

.device-status-badge.stale {
  background: rgba(255, 183, 77, 0.15);
  color: #FFB74D;
  border: 1px solid rgba(255, 183, 77, 0.3);
  animation: pulse-badge 2s ease-in-out infinite;
}

.status-icon {
  font-size: 14px !important;
  margin: 0;
}

.status-card {
  border-radius: 10px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--v-primary-darken1);
}

.status-container {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
}

.status-on {
  border: 3px solid #3CB371;
}

.status-off {
  border: 3px solid #FF5252;
}

.no-status {
  border: 3px solid #9E9E9E;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 14px;
}

@keyframes pulse-badge {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
</style>